import React, { FC } from 'react';
import { FileCategorySection } from '@flicent/fieldpulse-react-component-library-frontend';

import JobFileCategoriesProps from './JobFileCategories.props';


const JobFileCategories: FC<JobFileCategoriesProps> = ({ job }) => {
  if (!job.is_file_categories_section_visible || !job.file_categories?.length) {
    return null;
  }

  return (
    <>
      { job.file_categories.map((fileCategory) => (
        <FileCategorySection key={ fileCategory.id } fileCategory={ fileCategory } fileSize={ job.file_size }/>
      )) }
    </>
  );
};


export default JobFileCategories;